import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Label
} from 'recharts';

interface ChartDataItem {
  year: string;
  units: number;
}

interface HousingByYearChartProps {
  data: ChartDataItem[];
}

// To make sure the first column and last column don't say "Built in Before 1960" and "Built in 2010+"
const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    let tooltipTitle;
    if (label === 'Before 1960') {
      tooltipTitle = 'Built before 1960';
    } else if (label === '2010+') {
      tooltipTitle = 'Built in 2010 or Later';
    } else {
      tooltipTitle = `Built in ${label}`;
    }

    return (
      <div className="bg-white p-2 border border-gray-300 rounded shadow-lg">
        <p className="font-semibold">{tooltipTitle}</p>
        <p>Units: {payload[0].value.toLocaleString()}</p>
      </div>
    );
  }
  return null;
};

export const HousingByYearChart: React.FC<HousingByYearChartProps> = ({
  data,
}) => {
  if (!data || data.length === 0) {
    return <div className="flex items-center justify-center h-full text-gray-500">No data available for chart.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 40,
          bottom: 20,
        }}
      >
        <defs>
          <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#ca0270" stopOpacity={0.8}/>
            <stop offset="95%" stopColor="#908ddb" stopOpacity={0.8}/>
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="year">
           <Label value="Year Built" offset={-10} position="insideBottom" />
        </XAxis>
        <YAxis>
            <Label value="Number of Units" offset={-10} angle={-90} position="insideLeft" style={{ textAnchor: 'middle' }} />
        </YAxis>
        <Tooltip cursor={{ fill: 'rgba(202, 2, 112, 0.1)' }} content={<CustomTooltip />} />
        <Bar dataKey="units" fill="url(#colorGradient)" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}; 